import { configureStore } from '@reduxjs/toolkit';
import approvalQueueSlice from './approvalQueue/approvalQueueSlice';
import { athenaApi } from './athenaApi';
// Side-effect import: applies invalidatesTags overrides on top of the generated
// endpoints (e.g. library-directory mutations also invalidate 'Library' so the
// tree refetches — issue #1333). Must load at startup, before any mutation.
import './athenaApiEnhanced';
import ctpSlice from './ctp/ctpSlice';
import deliverablesSlice from './deliverables/deliverablesSlice';
import financialsTabularSlice from './financials/financialsTabularSlice';
import financialPlansSlice from './financialPlans/financialPlansSlice';
import librarySlice from './library/librarySlice';
import menuSlice from './menu/menuStateSlice';
import pnrSlice from './pnr/pnrSlice';
import projectsSlice from './projects/projectsSlice';
import ripSlice from './rip/ripSlice';
import tarSlice from './tar/tarSlice';
import tarImcsSlice from './tar-imcs/tarImcsSlice';
import trSlice from './tr/trSlice';
import userSlice from './user/userStateSlice';

export const store = configureStore({
  reducer: {
    approvalQueue: approvalQueueSlice,
    ctp: ctpSlice,
    deliverables: deliverablesSlice,
    financialsTabular: financialsTabularSlice,
    financialPlans: financialPlansSlice,
    library: librarySlice,
    menu: menuSlice,
    pnr: pnrSlice,
    user: userSlice,
    projects: projectsSlice,
    rip: ripSlice,
    tar: tarSlice,
    tarImcs: tarImcsSlice,
    tr: trSlice,
    [athenaApi.reducerPath]: athenaApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(athenaApi.middleware),
});

// Get the type of our store variable
export type AppStore = typeof store;
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
